require('../../scss/frontend/servicePage.scss');

document.addEventListener("DOMContentLoaded", function (event) {
    console.log('initPage');
    function scrollable() {
        if ($('.tab-fake').length == 0) {
            var minWidth = 0;
            var lastWidth = 0;
            var tabContainerWidth = $('.tabs').width();
            $('.nav-item:not(.prev,.next)').each(function () {
                minWidth += $(this).width();
                lastWidth = $(this).width();
            });
            var width = tabContainerWidth;
            if (tabContainerWidth < minWidth) {
                width = minWidth + 1;
                $('.nav-tabs').css('minWidth', width + 'px');
                $('.tabs').addClass('scrollable')
            } else {
                $('.tabs').removeClass('scrollable')
            }
        } else {
            var maxHeight = 0;
            $('.tabs').each(function () {
                var rect = this.getBoundingClientRect();
                if (maxHeight < rect.height) {
                    maxHeight = rect.height;
                }
            });
            $('#slider-tab').css('minHeight', (maxHeight + 100) + 'px');

            var attacced = false;
            var slideEl = document.getElementById("slider-tab");
            $(window).scroll(function () {
                if (!attacced) {
                    var rect = slideEl.getBoundingClientRect();
                    if (rect.y + 150 < window.innerHeight) {
                        attacced = true;
                        setTimeout(function () {
                            $('head').append('<style>.flickity-slider {  width: calc(100% - 10px); }</style>');
                        }, 250);
                    }
                }
            });
        }
    }

    scrollable();
    $(window).resize(scrollable);

    $('.nav-item.next').click(function () {
        $('.horizontal-scroll').animate({scrollLeft: '+=' + $('.tabs').width() / 1.5 + 'px'}, 800);
    });
    $('.nav-item.prev').click(function () {
        $('.horizontal-scroll').animate({scrollLeft: '-=' + $('.tabs').width() / 1.5 + 'px'}, 800);
    });

    console.log("Set Scroll check");
    $('.horizontal-scroll').scroll(function () {
        clearTimeout($.data(this, 'scrollTimer'));
        setTabVisible();
        $.data(this, 'scrollTimer', setTimeout(function () {
            console.log("Haven't scrolled in 250ms!");
        }, 250));
    });

    function setTabVisible() {
        var $tabs = $('.nav-link');
        var $prev = $('.nav-item.prev');

        var rect = $prev[0].getBoundingClientRect();
        var targetX = rect.x + rect.width;

        var triggerEl = null;
        var min = 9999;

        $tabs.each(function () {
            var rect = this.getBoundingClientRect();

            if (Math.abs(rect.x - targetX) < Math.abs(min)) {
                triggerEl = this;
                min = rect.x - targetX;
            }
        });

        var $el = $(triggerEl);
        $el.tab('show');
    }
});